import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from 'src/app/core/auth/services';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { IconsModule } from 'src/app/core/icons/icons.module';
import { PhonePipe } from 'src/app/core/pipes/pipes/phone.pipe';
import { QuoteSteps } from 'src/app/shared/constants/quote-steps.constant';

@Component({
    selector: 'pkd-navbar-nav',
    imports: [IconsModule, CommonModule, PhonePipe],
    templateUrl: './navbar-nav.component.html',
    styleUrl: './navbar-nav.component.scss'
})
export class NavbarNavComponent {
	@Input() customClass: string;
	@Input() useAltHeader = false;
	@Output() navigated: EventEmitter<boolean> = new EventEmitter();

	public currentTab: 'dashboard' | 'profile' = 'dashboard';

	constructor(
		private appStateService: AppStateService,
		private router: Router,
		private authService: AuthService,
	) {
		this.appStateService.onSetNavbarTab.subscribe(tab => {
			this.currentTab = tab;
		});
	}

	public closeCanvas(): void {
		this.navigated.emit(true);
	}

	public goSmartBegin() {
		this.router.navigate(['/']);
		this.appStateService.goToStep(QuoteSteps.SMART_BEGIN);
		this.closeCanvas();
	}

	public navigateToSection(sectionId: string) {
		// First navigate to the home page if not already there
		if (window.location.pathname !== '/') {
			this.router.navigate(['/'], { queryParams: { section: sectionId } }).then(() => {
				this.scrollToSection(sectionId);
			});
		} else {
			// Update the URL with section parameter
			this.router
				.navigate([], {
					queryParams: { section: sectionId },
					queryParamsHandling: 'merge',
				})
				.then(() => {
					this.scrollToSection(sectionId);
				});
		}
		this.closeCanvas();
	}

	private scrollToSection(sectionId: string) {
		// Wait for the page to load, then scroll to the section
		setTimeout(() => {
			const element = document.getElementById(sectionId);
			if (element) {
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}
		}, 100);
	}

	public async getRates(): Promise<void> {
		this.appStateService.goToStep(QuoteSteps.ONBOARDING);
		this.closeCanvas();
	}

	get isPortal() {
		return window.location.pathname.split('/').filter(Boolean)[0] === 'portal';
	}

	get isLoggedIn() {
		return !!this.authService.authFields?.loggedInUser;
	}

	get promoCode() {
		return this.appStateService?.promoCode;
	}

	public reload() {
		location.reload();
	}

	public navigateTo(path: 'dashboard' | 'profile') {
		this.router.navigate(['/portal', path]);
		this.currentTab = path;
		this.closeCanvas();
	}

	public logout() {
		this.authService.logout();
		this.closeCanvas();
	}

	public goLoginPage() {
		this.router.navigate(['/login']);
		this.closeCanvas();
	}
}
